import { render, staticRenderFns } from "./Transfert.vue?vue&type=template&id=f961db2e"
import script from "./Transfert.vue?vue&type=script&lang=ts"
export * from "./Transfert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports